import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { EncryptPwdService } from './services/encrypt-pwd.service';
import { MetaService } from './services/meta-service.service';
import { QuizService } from './services/quiz.service';
import { UserService } from './services/user.service';
import { SmoothScrollService } from '@boatzako/ngx-smooth-scroll';
import { DiscussionService } from './services/discussion.service';
import { AppConfig } from '../app.config';
import { ModalPopupService } from './services/modal-popup.service';
import { MatDialogModule } from '@angular/material/dialog';
import { ChatService } from './services/chat.service';

const sharedRoutes:Routes=[];

function initConfig(config: AppConfig){
  return () => config.load()
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatDialogModule,
    RouterModule.forChild(sharedRoutes)
  ],
  exports:[]
})
export class SharedServiceModule {
  constructor() {

  }
  static forRoot(): ModuleWithProviders<SharedServiceModule> {
    return {
      ngModule: SharedServiceModule,
      providers:[EncryptPwdService,
        // AppConfig,
        // { provide: APP_INITIALIZER, useFactory: initConfig, deps: [AppConfig,        QuizService,
        //   UserService,], multi: true },
        MetaService,
        QuizService,
        UserService,
          DiscussionService,
           SmoothScrollService,
           ModalPopupService,
           ChatService
      ]
    }
  }
}
